import React, { useState, useEffect } from "react";
import './css_pages/Stores.css'
import {  FaPlus, FaTimes } from 'react-icons/fa';
import './css_pages/Stores.css'
import { getAllStores, createStore, updateStore, deleteStore } from '../services/storesService';

function Stores(){
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [storeName , setStoreName ] = useState('');
    const [storeAddress, setStoreAddress] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [deleteId, setDeleteId] = useState(null);
    const [advancedSearchAddress, setAdvancedSearchAddress] = useState('');
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchStores();
    }, []);

    const fetchStores = async () => {
        try{
            setLoading(true);
            setError(null);
            const response = await getAllStores();
            if(response.success){
                setStores(response.data);
            }
        }catch (error){
            setError("Error loading store data")
            console.error('Error', error);
        }finally{
            setLoading(false);
        }
    };

    const filteredStores = stores.filter(store =>{ 
        const matchesName = store.name.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesAddress = advancedSearchAddress === '' || 
            store.address.toLowerCase().includes(advancedSearchAddress.toLowerCase());
        return matchesName && matchesAddress;
    });

    const handleOpenModal = () => {
        setShowModal(true);
        setStoreName('');
        setStoreAddress('');
        setEditingId(null);
    };

    const handleEditModal = (store) => {
        setShowModal(true);
        setStoreName(store.name);
        setStoreAddress(store.address);
        setEditingId(store.id);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setStoreName('');
        setStoreAddress('');
        setEditingId(null);
    };

    const handleSaveStore = async () =>{
        const normalizedName = storeName.trim();
        const normalizedAddress = storeAddress.trim();
        if(normalizedName === ''){
            alert('Enter the store name')
            return;
        }
        if(normalizedAddress === ''){
            alert('Enter the store address')
            return;
        }
        try{
            setLoading(true);
            if(editingId){
                const response = await updateStore(editingId, {name: normalizedName, address: normalizedAddress});
                if(response.success){
                    alert('Store updated successfully');
                    await fetchStores();
                    handleCloseModal();
                }
            }else{
                const response = await createStore({name: normalizedName, address: normalizedAddress});
                if(response.success){
                    alert('Store added successfully');
                    await fetchStores();
                    handleCloseModal();
                }
            }
        }catch(error){
            if(error.response && error.response.status === 409){
                alert('There is already a store with that name.');
            }else{
                alert('Error saving store');
            }
            console.error('Error', error);
        }finally{
            setLoading(false);
        }
    };

    const handleOpenDeleteModal = (id) => {
        setDeleteId(id);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setDeleteId(null);
    };

    const handleConfirmDelete = async () => {
        try{
            setLoading(true);
            const response = await deleteStore(deleteId);
            if(response.success){
                alert('Store Successfully Removed');
                await fetchStores();
            }
            handleCloseDeleteModal();
        }catch(error){
            alert('Error deleting store')
            console.error('Error', error);
        }finally{
            setLoading(false);
        }
    };
    
    return(
        <div className="stores-page">
            <div className="page-header">
                <div className="header-left">
                    <h1>Stores</h1>
                </div>
                <button className="btn-primary" onClick={handleOpenModal} disabled={loading}>
                    <FaPlus /> Create new store
                </button>
            </div>

            {error && (
                <div className="error-message">
                    {error}
                    <button onClick={fetchStores}>Retry</button>
                </div>
            )}

            <div className="search-section">
                <div className="search-bar">
                    <input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>
            </div>

            {/* Table - Desktop */}
            <div className="table-container desktop-only">
                {loading && <div className="loading">Loading...</div>}

                <table className="data-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Address</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredStores.length === 0 ? (
                            <tr>
                                <td colSpan="3" style={{textAlign: 'center', padding: '40px'}}>
                                    {loading ? 'Loading...' : 'No results found'}
                                </td>
                            </tr>
                        ) : ( 
                            filteredStores.map((store)=>(
                                <tr key={store.id}>
                                    <td>{store.name}</td>
                                    <td>{store.address}</td>
                                    <td>
                                        <button className="btn-action" onClick={() => handleEditModal(store)} disabled={loading}>Edit</button>
                                        <button className="btn-action btn-delete" onClick={() => handleOpenDeleteModal(store.id)} disabled={loading}>Delete</button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Cards - Mobile */}
            <div className="stores-cards-container mobile-only">
                {loading && <div className="loading">Loading...</div>}
                
                {filteredStores.length === 0 ? (
                    <div className="no-results">
                        {loading ? 'Loading...' : 'No results found'}
                    </div>
                ) : (
                    filteredStores.map((store) => (
                        <div key={store.id} className="store-card">
                            <div className="store-card-header">
                                <h3 className="store-card-name">{store.name}</h3>
                            </div>

                            <div className="store-card-body">
                                <div className="store-card-row">
                                    <div className="store-card-item">
                                        <span className="store-card-label">Address</span>
                                        <span className="store-card-value">{store.address}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="store-card-footer">
                                <button 
                                    className="btn-card-action btn-edit" 
                                    onClick={() => handleEditModal(store)}
                                    disabled={loading}
                                >
                                    Edit
                                </button>
                                <button 
                                    className="btn-card-action btn-delete-card" 
                                    onClick={() => handleOpenDeleteModal(store.id)}
                                    disabled={loading}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>{editingId ? 'Edit Store': 'Create new store'}</h2>
                            <button className="btn-close" onClick={handleCloseModal}>
                                <FaTimes/>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="form-group">
                                <label> Name *</label>
                                <input type="text" value={storeName} onChange={(e) => setStoreName(e.target.value)} placeholder="Enter the store name" autoFocus disabled={loading} />
                            </div>

                            <div className="form-group">
                                <label> Address *</label>
                                <input type="text" value={storeAddress} onChange={(e) => setStoreAddress(e.target.value)} placeholder="Enter the store address" disabled={loading} />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn-secondary" onClick={handleCloseModal} disabled={loading}>
                                Cancel
                            </button>
                            <button className="btn-primary" onClick={handleSaveStore} disabled={loading}>
                                {loading ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showDeleteModal && (
                <div className="modal-overlay">
                    <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Confirm deletion</h2>
                            <button className="btn-close" onClick={handleCloseDeleteModal}>
                                <FaTimes/>
                            </button>
                        </div>

                        <div className="modal-body">
                            <p>Are you sure you want to delete this store?</p>
                            <p className="warning-text">This action cannot be undone.</p>
                        </div>

                        <div className="modal-footer">
                            <button className="btn-secondary" onClick={handleCloseDeleteModal} disabled={loading}>
                                Cancel
                            </button>
                            <button className="btn-danger" onClick={handleConfirmDelete} disabled={loading}>
                                {loading ? 'Removing...' : 'Eliminate'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default Stores;